import { render, staticRenderFns } from "./con_school.vue?vue&type=template&id=2b290c39"
import script from "./con_school.vue?vue&type=script&lang=js"
export * from "./con_school.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports